import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/'
Vue.use(Router)

const routes={
  mode:'history',
  routes: [
    {
      path: '/',
      redirect:'/login'
    },{
      path: '/login',
      name: 'login',
      // component:   () => import(/* webpackChunkName: 'login' */ '@/page/login')
      component:   () => import(/* webpackChunkName: 'login' */ '@/page/loginDB')
    }
  ]
}
const router=new Router(routes);
import {adminRouter,commonRouter,deptRouter,docRouter} from './staticRoute'
router.beforeEach(function (to, from, next) {
  if(window.sessionStorage.getItem('userInfo')){
    if(store.state.addRouter==0){
        //组织路由
        let roles=window.sessionStorage.getItem('roleList');
        if(roles!=null){
          let newRouter=commonRouter
          if(roles.indexOf('hosp_admin')>-1){
              newRouter=newRouter.concat(adminRouter);
          }
          if(roles.indexOf('dept_admin')>-1){
              newRouter=newRouter.concat(deptRouter);
          }
          if(roles.indexOf('doc')>-1){
              newRouter=newRouter.concat(docRouter);
          }
          let endRouter=[
              {
                  path: '/home',
                  component: () => import(/* webpackChunkName: 'home' */ '@/page/home'),
                  children: newRouter
              }
          ];
          router.addRoutes(endRouter);
          store.state.addRouter=1;
          next(to.path);
        }
        next();
    }
    else{
        next();
    }
}else{
    next();
}
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js